module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_gaseosas_vidrio_350_fn.39d4898b.png";